import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AssetVehicleEntryService } from '../asset-vehicle-entry.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { error } from 'jquery';
import { DialogAssetVehicleEntryComponent } from '../dialog-asset-vehicle-entry/dialog-asset-vehicle-entry.component';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-asset-vehicle-details',
  templateUrl: './asset-vehicle-details.component.html',
  styleUrls: ['./asset-vehicle-details.component.scss']
})
export class AssetVehicleDetailsComponent implements OnInit {
  displayedColumns: string[] = ['orcFusionBuildingCode', 'buildingName', 'orgName', 'minorCategoryName', 'vehicleNumber', 'approveStatus'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  dataAvailable = true;
  tableList: any;
  assetvehiclelist: any;
  constructor(private assetvehicle: AssetVehicleEntryService, private spinner: NgxSpinnerService, public dialog: NgDialogAnimationService,) { }
  ngOnInit(): void {
    this.tableVehicle();
  }
  tableVehicle() {
    this.spinner.show();
    this.assetvehicle.getvehicletable().subscribe(
      {
        next: (res: any) => {
          this.tableList = res;
          console.log('tableList', this.tableList);
          this.assetvehiclelist = new MatTableDataSource(this.tableList);
          this.assetvehiclelist.sort = this.sort;
          this.assetvehiclelist.paginator = this.paginator;
          this.dataAvailable = true;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  pending() {
    const dialogRef = this.dialog.open(DialogAssetVehicleEntryComponent, {
      direction: 'ltr',
      height: '100%',
      width: '35%',
      position: { right: '0px', top: '0px' },
      animation: { to: 'left' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.tableVehicle();
        console.log('result', result);
      }
    });
  }

  applyFilter(e: any) {
    const filterValue = (e.target as HTMLInputElement).value;
    this.assetvehiclelist.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }

}
